const SEE_MORE_TYPES = ['similar-style', 'view-together'];

/**
 * GoodsList analytics SCREEN 값.
 * iOS `RelatedGoodsListType.metaFeedScreen`와 동일: 케밥 endpoint(`similar-style`/`view-together`)는
 * `SEE_MORE`로 통일, 그 외는 `type` 대문자.
 */
export const getGoodsListScreen = (type: string) =>
  SEE_MORE_TYPES.includes(type) ? 'SEE_MORE' : type.toUpperCase();
